module.exports = __webpack_public_path__ + "static/media/CakeRusk 300 g.4f03b81f.jpg";